import * as React from "react";
import { ThemeBreakpoints, ThemePalette, ThemePaletteState, ThemeShadowSizes, ThemeSize } from "../../../../theme/_Types";
import { Container } from "../../03-base/Container";
import { Div } from "../../03-base/Div";
import { FlexColumn } from "../../03-base/Flex/Column";
import { FlexRow } from "../../03-base/Flex/Row";
import { FillUp } from "../../04-helpers/FillUp";
import { Button } from "../../05-atoms/Button";
import { Alignment, ButtonsWrapper, Orientation } from "../../06-molecules/ButtonsWrapper";
import { Modal } from "../../06-molecules/Modal";
import { Navbar } from "../../07-organisms/Navbar";
import { NavbarStack, NavbarStackContent } from "../../07-organisms/Navbar/Stack";
import { NavbarTitle } from "../../07-organisms/Navbar/Title";
import * as I18n from "../../../../utils/translations/I18n";
import { mailToData, refreshMary } from "../../../../utils/General";
var errorModal = function (info) {
    var _a;
    return (React.createElement(Modal, { modalID: "error", theme: { size: ThemeSize.SMALL }, inline: true },
        React.createElement(FlexColumn, { theme: {
                palette: ThemePalette.CONTRAST_PRIMARY,
                shadow: ThemeShadowSizes.HUGE,
            } },
            React.createElement(FlexRow, { isFixed: true },
                React.createElement(Navbar, { theme: {
                        paletteState: ThemePaletteState.DANGER,
                    } },
                    React.createElement(NavbarStack, null,
                        React.createElement(NavbarStackContent, null,
                            React.createElement(NavbarTitle, null, I18n.getText("mary.09-views.02-pages.error.title", "Oops, something went wrong!")))))),
            React.createElement(FlexRow, { theme: {
                    palette: ThemePalette.CONTRAST_PRIMARY,
                } },
                React.createElement(FlexColumn, null,
                    React.createElement(FlexRow, { isScrollable: true },
                        React.createElement(FillUp, null,
                            React.createElement(Container, { theme: {
                                    padding: {
                                        "": { y: 3 },
                                        "md": { y: 4 },
                                    },
                                } },
                                React.createElement("div", { className: "scl-b-h5" }, I18n.getText("mary.09-views.02-pages.error.content-title", "There has been a technical error")),
                                React.createElement("br", null),
                                React.createElement("p", null, I18n.getText("mary.09-views.02-pages.error.content-description", "Send the following information to team Claude of VWPFS.")),
                                React.createElement("br", null),
                                React.createElement(Div, { style: { maxHeight: "200px", overflowY: "scroll", wordWrap: "break-word" }, theme: {
                                        palette: ThemePalette.CONTRAST_SECONDARY,
                                        padding: {
                                            "": { y: 2, x: 2 },
                                            "md": { y: 3, x: 3 },
                                        }
                                    } }, info ||
                                    I18n.getText("mary.09-views.02-pages.error.content-fallback-message", 
                                    // eslint-disable-next-line max-len
                                    "Claude is not able to collect technical data, this seems to be a serious problem. :("))))))),
            React.createElement(FlexRow, { isFixed: true },
                React.createElement(FlexColumn, { theme: {
                        palette: ThemePalette.CONTRAST_SECONDARY,
                    } },
                    React.createElement(Container, { theme: {
                            padding: {
                                "": { y: 3 },
                            },
                        } },
                        React.createElement(ButtonsWrapper, { defaultOrientation: Orientation.HORIZONTAL, orientations: (_a = {}, _a[ThemeBreakpoints.XS] = Orientation.HORIZONTAL, _a), alignment: Alignment.RIGHT },
                            React.createElement(Div, { style: { display: "flex" } },
                                React.createElement(Button, { theme: {
                                        palette: ThemePalette.CONTRAST_SECONDARY,
                                    }, link: { onClick: refreshMary } }, I18n.getText("mary.09-views.refresh-btn", "Refresh the page"))),
                            React.createElement(Div, { style: { display: "flex" } },
                                React.createElement(Button, { theme: {
                                        palette: ThemePalette.BRAND_ACCENT,
                                    }, link: { href: mailToData(info || "no data collected.") } }, I18n.getText("mary.09-views.02-pages.error.send-btn", "Send data"))))))))));
};
/**
 *
 * @param props
 */
export var ErrorView = function (props) { return (React.createElement(FlexColumn, { isPage: true, hasScrollable: true, theme: {
        palette: ThemePalette.CONTRAST_SECONDARY,
    } },
    React.createElement(FlexRow, { isScrollable: true },
        React.createElement(FillUp, { theme: {
                palette: ThemePalette.CONTRAST_SECONDARY,
            } }, errorModal(props.info))))); };
